export let ChameleonEvents = /*#__PURE__*/function (ChameleonEvents) {
  ChameleonEvents["Tours"] = "tour:event";
  return ChameleonEvents;
}({});
export let ChameleonTourEventsValues = /*#__PURE__*/function (ChameleonTourEventsValues) {
  ChameleonTourEventsValues["CompletedTour"] = "Completed Tour";
  ChameleonTourEventsValues["ExitedTour"] = "Exited Tour";
  ChameleonTourEventsValues["StartedTour"] = "Started Tour";
  ChameleonTourEventsValues["StepSeen"] = "Step Seen";
  ChameleonTourEventsValues["DismissClicked"] = "Dismiss clicked";
  return ChameleonTourEventsValues;
}({});
export let ChameleonToursLaunch = /*#__PURE__*/function (ChameleonToursLaunch) {
  ChameleonToursLaunch["Force"] = "forceLaunch";
  ChameleonToursLaunch["Initial"] = "initialLaunch";
  return ChameleonToursLaunch;
}({});
export let DemoInventoryWarningTypes = /*#__PURE__*/function (DemoInventoryWarningTypes) {
  DemoInventoryWarningTypes["Products"] = "Products";
  DemoInventoryWarningTypes["GiveawayUploadLinks"] = "GiveawayUploadLinks";
  DemoInventoryWarningTypes["GiveawaySingleLink"] = "GiveawaySingleLink";
  DemoInventoryWarningTypes["RenameProduct"] = "RenameProduct";
  DemoInventoryWarningTypes["RemoveShipout"] = "RemoveShipout";
  DemoInventoryWarningTypes["PaymentMethodsAdd"] = "PaymentMethodsAdd";
  DemoInventoryWarningTypes["PaymentMethodsEdit"] = "PaymentMethodsEdit";
  DemoInventoryWarningTypes["PaymentMethodsRemove"] = "PaymentMethodsRemove";
  DemoInventoryWarningTypes["RenameInventory"] = "RenameInventory";
  DemoInventoryWarningTypes["InviteToInventory"] = "InviteToInventory";
  DemoInventoryWarningTypes["GiveawayPayment"] = "GiveawayPayment";
  DemoInventoryWarningTypes["GiveawayEnd"] = "GiveawayEnd";
  DemoInventoryWarningTypes["TransferProducts"] = "TransferProducts";
  DemoInventoryWarningTypes["RemoveGiveawayRecipient"] = "RemoveGiveawayRecipient";
  DemoInventoryWarningTypes["ApprovalFlowActions"] = "ApprovalFlowActions";
  DemoInventoryWarningTypes["RevokeAccess"] = "RevokeAccess";
  DemoInventoryWarningTypes["BuyCredits"] = "BuyCredits";
  DemoInventoryWarningTypes["WithdrawCredits"] = "WithdrawCredits";
  DemoInventoryWarningTypes["CreateBundle"] = "CreateBundle";
  return DemoInventoryWarningTypes;
}({});